import React from 'react';
import { graphql } from 'gatsby';
import { CaseStudyFeed as CaseStudyFeedComponent } from '../../CaseStudyFeed';

export const CaseStudyFeed = ({ data, ...rest }) => <CaseStudyFeedComponent {...data} {...rest} />;

export const CaseStudyFeedQuery = graphql`
  fragment CaseStudyFeed on KFH_UmbracoCaseStudyFeedComponentType {
    title
    backgroundColour
    caseStudies {
      pageName
      relativeUrl
      feed {
        shortTitle
        featuredImage {
          altText
          localFile {
            gatsbyImage(
              width: 452
              height: 340
              layout: CONSTRAINED
              placeholder: NONE
              quality: 80
              backgroundColor: "#F5F5F5"
            )
          }
        }
      }
    }
  }
`;
